import { Grid, Skeleton, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { SectionPaper } from "../SectionPaper";
import { useDispatch, useSelector } from "react-redux";
import { getPathStats } from "../../Slices/competencePaths";
import { useTheme } from "@mui/material/styles";


const StatsBox = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const badgesStats = useSelector((state) => state.competencePahts.pathStats);

  useEffect(() => {
    dispatch(getPathStats());
  }, [dispatch]);

  return (
    <SectionPaper elevation={3}>
      <Grid container spacing={0} sx={{ height: "100%" }}>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            component="h3"
            variant="h7"
            sx={{
              fontSize: "14px",
              lineHeight: 1.4,
              textAlign: "left",
              marginLeft: "20px",
              color: theme.palette.secondary.title,
            }}
          >
            ilość wydanych odznak / mikropoświadczeń:
          </Typography>
          {badgesStats?.all_issued_badges ? (
            <Typography
              component="span"
              variant="h4"
              sx={{
                marginLeft: "10px",
                marginRight: "10px",
                color: theme.palette.texts.text1,
              }}
            >
              {badgesStats?.all_issued_badges}
            </Typography>
          ) : (
            <Skeleton variant="rounded" width={40} height={40} sx={{ mr: 2 }} />
          )}
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            component="h3"
            variant="h7"
            sx={{
              fontSize: "14px",
              lineHeight: 1.4,
              textAlign: "left",
              marginLeft: "20px",
              color: theme.palette.secondary.title,
            }}
          >
            Ilość wydanych certyfikatów:
          </Typography>
          {badgesStats?.gold_issued_badges ? (
            <Typography
              component="span"
              variant="h4"
              sx={{
                marginLeft: "10px",
                marginRight: "10px",
                color: theme.palette.texts.text1,
              }}
            >
              {badgesStats?.gold_issued_badges}
            </Typography>
          ) : (
            <Skeleton variant="rounded" width={40} height={40} sx={{ mr: 2 }} />
          )}
        </Grid>
      </Grid>
    </SectionPaper>
  );
};

export default StatsBox;
